import { useCallback, useEffect, useState } from 'react';
import { RelocationFromEmailResult } from './types';

export const useRelocationFormEmail = (): RelocationFromEmailResult => {
  const initial = window.localStorage.getItem('relocationFormEmail');
  const [savedEmail, setSavedEmail] = useState<string | null>(
    initial ? JSON.parse(initial) : null,
  );

  // Updates local storage
  useEffect(() => {
    window.localStorage.setItem(
      'relocationFormEmail',
      JSON.stringify(savedEmail),
    );
  }, [savedEmail]);

  const saveEmail = useCallback(
    (email: string) => {
      if (!savedEmail) {
        setSavedEmail(email);
      }
    },
    [savedEmail],
  );

  return {
    data: {
      savedEmail,
    },
    actions: {
      saveEmail,
    },
  };
};
